<template>
  <div class="mt-6">
    <v-row>
      <v-col
        v-for="(availability, index) in localValue"
        :key="index"
        cols="12"
        :sm="rowColSize"
      >
        <v-row>
          <v-col cols="12" :sm="colSize">
            <date-time-picker
              v-model="availability.start_date"
              label="Inizio"
            ></date-time-picker>
          </v-col>
          <v-col cols="12" :sm="colSize">
            <date-time-picker
              v-model="availability.end_date"
              label="Fine"
            ></date-time-picker>
          </v-col>
          <v-col v-if="hasPlace" cols="12" :sm="colSize">
            <autocomplete
              v-model="availability.show_place"
              :model="showPlaceModel"
              :extra-params="modelFk"
              item-text="place__name"
              item-value="id"
              label="Luogo"
            ></autocomplete>
          </v-col>
          <v-col cols="12" :sm="btnColSize">
            <v-btn
              style="margin-top: 1rem;"
              small
              color="error"
              outlined
              @click="removeAvailability(index)"
            >
              &times;
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-btn depressed small outlined @click="addAvailability">
      Aggiungi disponibilità
    </v-btn>
  </div>
</template>

<script>
import models from "@/models"

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    hasPlace: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPlaceModel: models.ShowPlace,
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(localValue) {
        this.$emit("input", localValue)
      },
    },
    rowColSize() {
      return this.hasPlace ? "12" : "6"
    },
    colSize() {
      return this.hasPlace ? "3" : "5"
    },
    btnColSize() {
      return this.hasPlace ? "3" : "2"
    },
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    addAvailability() {
      this.localValue.push({
        start_date: new Date().toISOString(),
        end_date: new Date().toISOString(),
      })
    },
    removeAvailability(index) {
      this.localValue.splice(index, 1)
    },
  },
}
</script>
